import { useState, useEffect, useRef } from "react";

import {
  CustomSearchInput,
  DataResult,
  DivIcon,
  ListItem,
  Wrapper,
  Avatar,
  InfoUser,
  Name,
  Email,
} from "./styles";
import ProfileCircle from "../../../../assets/icons/profileCircle";
import Popper from "../../Popper";

export function SearchInput({
  open,
  innerRef,
  placeholder,
  update,
  onClose = null,
  list = [],
}) {
  // const innerRef = useRef(null);
  const [filteredData, setFilteredData] = useState([]);
  const [wordEntered, setWordEntered] = useState("");

  const handleFilter = (event) => {
    const searchWord = event.target.value;
    setWordEntered(searchWord);
    const newFilter = list.filter((value) => {
      return value.username.toLowerCase().includes(searchWord.toLowerCase());
    });

    setFilteredData(newFilter);
  };

  useEffect(() => {
    setFilteredData(list);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrapper onClick={(e) => e.stopPropagation()} className="search">
      <Popper
        isOpen={open}
        onClose={onClose}
        anchorRef={innerRef}
        addHalf={false}
      >
        <CustomSearchInput
          type="text"
          placeholder={placeholder}
          value={wordEntered}
          onChange={handleFilter}
        />
        <DivIcon>
          <ProfileCircle height="1.5rem" />
        </DivIcon>
        {filteredData.length !== 0 && (
          <DataResult len={filteredData.length} className="dataResult">
            {filteredData.slice(0, 15).map((item) => (
              <ListItem
                onClick={() => {
                  update(item);
                }}
                key={item._id}
              >
                <Avatar src={item?.avatarURL} />
                <InfoUser>
                  <Name>{item?.username}</Name>
                  <Email>{item?.email}</Email>
                </InfoUser>
              </ListItem>
            ))}
          </DataResult>
        )}
      </Popper>
    </Wrapper>
  );
}
